export default "__VITE_ASSET__COH44oV4__"